




















import Vue from 'vue';
import FormField from './FormField.vue';
import MultiContainRelation from './MultiContainRelation.vue';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';
import { CustomerFilter } from '../../../models/CustomerFilter';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
    MultiContainRelation,
  },
  methods: {
    loadGroups() {
      customerClient.getGroups().success(r => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
      });
    },
    updateGroups(groups: number[]) {
      const v = this.customerState.customerFilter.group;
      v.groupIds = groups;
      this.updateGroupFilter(v);
    },
    updateRelation(notIn: boolean, or: boolean) {
      const v = this.customerState.customerFilter.group;
      v.notIn = notIn;
      v.or = or;
      this.updateGroupFilter(v);
    },
    updateGroupFilter(filter: CustomerFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'group',
        value: filter,
      });
    },
  },
  mounted() {
    this.loadGroups();
  },
});
